<app-split-screen-form-based-modal [config]="formConfig$ | async" (submitForm)="handleSubmit()">
  <!-- Logo -->
  <div slot="header-content">
    <div class="logo-container">
      <svg-icon icon="pencil_spaces" width="211" height="30"></svg-icon>
    </div>
  </div>

  <!-- Form Content -->
  <div slot="form-content">
    <!-- Header Section -->
    <div class="split-screen-header-section">
      <div class="split-screen-main-title">{{ header.title | translate }}</div>
      <div class="split-screen-subtitle">{{ header.subtitle | translate }}</div>
    </div>

    <form [formGroup]="form" class="form-container">
      <ng-container *ngIf="mode !== Mode.LEGAL_AGREEMENTS">
        <!-- Name Field -->
        <div class="form-control-row">
          <label for="user-info-input-name" class="input-label">
            {{ "What's your name?" | translate }}
          </label>
          <input
            id="user-info-input-name"
            type="text"
            class="dialog-text-input"
            [class.has-error]="form?.controls.name.touched && form?.controls.name.errors"
            formControlName="name"
            placeholder="{{ 'Enter name here' | translate }}"
            [autofocus]="!form.value.name"
          />
          <div
            class="error-message"
            *ngIf="
              form?.controls.name.touched &&
              (form?.controls.name.errors?.required || form?.controls.name.errors?.whitespace)
            "
          >
            {{ 'Name is required' | translate }}
          </div>
          <div class="error-message" *ngIf="form?.controls.name.errors?.maxlength">
            {{ "Name should not exceed {{maxLength}} characters" | translate: {maxLength:
            maxNameLength} }}
          </div>
        </div>

        <!-- Role Selection -->
        <ng-container *ngIf="data.isSpaceRoute; else generalRoleTemplate">
          <ng-container *ngTemplateOutlet="spaceRoleTemplate"></ng-container>
        </ng-container>
      </ng-container>

      <!-- Legal agreements -->
      <div class="form-control-row" *ngIf="mode !== Mode.NAME_AND_ROLE">
        <label class="legal-agreements-consent">
          <input id="user-info-input-legal-agreements" type="checkbox" formControlName="acceptedLegalAgreements" />
          <span>
            {{ 'I agree to the' | translate }}
            <a
              href="https://www.pencilspaces.com/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ 'Terms of Service' | translate }}
            </a>
            {{ 'and acknowledge the' | translate }}
            <a
              href="https://www.pencilspaces.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ 'Privacy Policy' | translate }}
            </a>
          </span>
        </label>
        <div
          class="error-message"
          *ngIf="form?.controls.acceptedLegalAgreements.touched && form?.controls.acceptedLegalAgreements.errors"
        >
          {{ 'You must agree to continue' | translate }}
        </div>
      </div>
    </form>
  </div>

  <!-- Preview Content -->
  <div slot="preview-content">
    <div class="image-container">
      <img src="assets/imgs/wb-equation.png" alt="Preview Content" />
    </div>
  </div>
</app-split-screen-form-based-modal>

<!-- Reusable Role Error Template -->
<ng-template #roleErrorTemplate>
  <div
    class="error-message"
    *ngIf="
      form?.controls.info?.controls.role?.touched &&
      form?.controls.info?.controls.role?.errors?.required
    "
  >
    {{ 'This field is required' | translate }}
  </div>
</ng-template>

<!-- Role Selection - General -->
<ng-template #generalRoleTemplate>
  <div class="form-control-row">
    <div class="input-label">
      {{ "What's your role?" | translate }}
    </div>
    <app-radio-group-input
      [options]="roleOptions"
      [hasError]="
        form?.controls.info?.controls.role?.touched && form?.controls.info?.controls.role?.errors
      "
      (selectionChange)="setRoleValue($event)"
    ></app-radio-group-input>

    <ng-container *ngTemplateOutlet="roleErrorTemplate"></ng-container>
  </div>

  <!-- Description Dropdown - Teacher/Admin -->
  <div
    class="form-control-row"
    *ngIf="descriptionOptions[form?.controls.info?.controls.role?.value] as options"
  >
    <div class="input-label">
      {{ 'What describes you best?' | translate }}
    </div>

    <app-pencil-searchable-dropdown
      [dataSource]="options"
      [selectedItem]="form?.controls.info?.controls.role?.value"
      [placeholder]="'What describes you best?' | translate"
      [bindValue]="'value'"
      bindLabel="label"
      class="description-dropdown"
      [hasError]="
        form?.controls.info?.controls.roleDescription?.touched &&
        form?.controls.info?.controls.roleDescription?.errors
      "
      (selectedItemChanged)="setRoleDescription($event)"
    ></app-pencil-searchable-dropdown>

    <div
      class="error-message"
      *ngIf="
        form?.controls.info?.controls.roleDescription?.touched &&
        form?.controls.info?.controls.roleDescription?.errors?.required
      "
    >
      {{ 'This field is required' | translate }}
    </div>
  </div>
</ng-template>

<!-- Role Selection - Space Context -->
<ng-template #spaceRoleTemplate>
  <div class="form-control-row">
    <div class="input-label">
      {{ 'Are you a student?' | translate }}
    </div>
    <app-radio-group-input
      [options]="studentStatusOptions"
      [selectedOption]="defaultStudentStatus"
      (selectionChange)="setRoleValue($event)"
      [hasError]="
        form?.controls.info?.controls.role?.touched && form?.controls.info?.controls.role?.errors
      "
    ></app-radio-group-input>

    <ng-container *ngTemplateOutlet="roleErrorTemplate"></ng-container>
  </div>
</ng-template>
